let ZG_ENV = ''

if (process.env.VUE_APP_API) {
  console.log(process.env.VUE_APP_API)
  ZG_ENV = process.env.VUE_APP_API
} else if (window.location.href.indexOf('myseller.zhaogangtest.com') !== -1) {
  ZG_ENV = 'test'
} else if (
  window.location.href.indexOf('10.0.72.171') !== -1 ||
  window.location.href.indexOf('10.0.72.250') !== -1 ||
  window.location.href.indexOf('127.0.0.1') !== -1 ||
  window.location.href.indexOf('10.0.') !== -1 ||
  window.location.href.indexOf('localhost') !== -1
) {
  ZG_ENV = 'mit'
} else if (window.location.href.indexOf('myseller.zhaogangmit.com') !== -1) {
  ZG_ENV = 'mit'
} else if (window.location.href.indexOf('myseller.zhaoganguat.com') !== -1) {
  ZG_ENV = 'uat'
}
let PARALLEL_ENV = ''
if (window.location.href.indexOf('alphamyseller.zhaogang') !== -1) {
  PARALLEL_ENV = 'alpha'
} else if (window.location.href.indexOf('betamyseller.zhaogang') !== -1) {
  PARALLEL_ENV = 'beta'
}

let API_ROOT = `//${PARALLEL_ENV}api.zhaogang${ZG_ENV}.com`

let ZM_ROOT = `//zmall.zhaogang${ZG_ENV}.com`

let BUYER = `//buyer1.zhaogang${ZG_ENV}.com`

let SELLER = `//seller.zhaogang${ZG_ENV}.com`

let V2_ROOT = `//v2.zhaogang${ZG_ENV}.com`

let SELLER_ROOT = `//myseller.zhaogang${ZG_ENV}.com`

let HOME_ROOT = `http://www.zhaogang${ZG_ENV}.com`

let MAIL_ROOT = `//mail.zhaogang${ZG_ENV}.com`

let ACTIVITY_ROOT = `https://activity.zhaogang${ZG_ENV}.com`

let GOU_ROOT = `http://gou.zhaogang${ZG_ENV}.com`

let UPLOAD_ROOT = `//filegw.zhaogang${ZG_ENV}.com/file/upload`

let FILE_ROOT = `//f.zhaogang.com/`

let FILE_ACCESS_PRIVATE = `//fs.zhaogang${ZG_ENV}.com/filegw/dl?_aid=4&_fk=`

let COOKIE_DOMAIN = `.zhaogang${ZG_ENV}.com`

let OUTSERVE_ROOT = `http://outserver.zhaogang${ZG_ENV}.com`

if (
  window.location.href.indexOf('127.0.0.1') !== -1 ||
  window.location.href.indexOf('10.0.') !== -1 ||
  window.location.href.indexOf('localhost') !== -1
) {
  COOKIE_DOMAIN = ''
}

//招商银行委托授权书
const AUTHORIZE_CMB = 'https://shadow.zhaogangimg.com/assets/hawk/V2-授权委托书(找钢网)-招行.doc'

const ORDER_STATUS = {
  WAITING_PAY: '待付款',
  WAITING_DELIVERY: '待发货',
  SHIPPING: '待收货',
  FINISH: '已完成',
  CANCEL: '已关闭',
  REFUNDED: '已关闭',
  RATED: '已评价',
  NOT_RATE: '未评价',
  REFUNDING: '退款中',
  DEPOSIT_REFUNDING: '保证金退款中',
  DEPOSIT_REFUNDED: '已退保证金',
  // 先货后款系列
  NO_PAY_WAITING_FINISH: '待付款已收货',
  NO_PAY_WAITING_DELIVERY: '待付款待发货',
  NO_PAY_WAITING_SHIPPING: '待付款待收货'
}

const CONTRACT_STATUS = {
  INIT: { key: 0, value: '' },
  SELLER_UNSIGNED: { key: 1, value: '卖家未签约' },
  BUYER_UNSIGNED: { key: 2, value: '买家未签约' },
  CANCEL: { key: 3, value: '已撤销' },
  BOTH_SIGNED: { key: 4, value: '双方已签约' }
}

const MENU_SORT = [
  {
    id: 1500,
    index: 0
  },
  {
    id: 1514,
    index: 1
  },
  {
    id: 1512,
    index: 2
  },
  {
    id: 1521,
    index: 3
  },
  {
    id: 1523,
    index: 4
  },
  {
    id: 1517,
    index: 5
  }
]

const RECEIVE_MODE = {
  1: '担保支付',
  2: '实时到账'
}

export {
  ZG_ENV,
  API_ROOT,
  SELLER_ROOT,
  ZM_ROOT,
  HOME_ROOT,
  MAIL_ROOT,
  ACTIVITY_ROOT,
  GOU_ROOT,
  UPLOAD_ROOT,
  FILE_ROOT,
  FILE_ACCESS_PRIVATE,
  ORDER_STATUS,
  COOKIE_DOMAIN,
  MENU_SORT,
  AUTHORIZE_CMB,
  V2_ROOT,
  BUYER,
  SELLER,
  CONTRACT_STATUS,
  OUTSERVE_ROOT,
  RECEIVE_MODE
}
